import type { Node, Edge } from '../../models/scene';
import type { ScenarioDelta } from './ScenarioDelta';

export interface ScenarioProjectionResult<StatusIndex = unknown> {
  nodes: Node[];
  edges: Edge[];
  statusIndex: StatusIndex | null;
  isScenarioActive: boolean;
  scenarioName: string | null;
  isEditingScenario: boolean;
}

export type ScenarioProjector<StatusIndex = unknown, TDelta = ScenarioDelta> = (
  baseNodes: Node[],
  baseEdges: Edge[],
  delta: TDelta
) => { nodes: Node[]; edges: Edge[]; statusIndex: StatusIndex };

export function computeProjectedScenarioView<StatusIndex = unknown, TDelta = ScenarioDelta>(
  baseNodes: Node[],
  baseEdges: Edge[],
  activeScenarioId: unknown,
  scenarioState: unknown,
  activeScenario: { delta: TDelta; name: string } | null,
  projector: ScenarioProjector<StatusIndex, TDelta>
): ScenarioProjectionResult<StatusIndex> {
  const isScenarioActive = activeScenarioId !== null && activeScenario !== null;
  const isEditingScenario = scenarioState === 'EDITING_SCENARIO';

  if (!isScenarioActive || !activeScenario) {
    return {
      nodes: baseNodes,
      edges: baseEdges,
      statusIndex: null,
      isScenarioActive: false,
      scenarioName: null,
      isEditingScenario: false,
    };
  }

  const { nodes, edges, statusIndex } = projector(
    baseNodes,
    baseEdges,
    activeScenario.delta
  );

  return {
    nodes,
    edges,
    statusIndex,
    isScenarioActive: true,
    scenarioName: activeScenario.name,
    isEditingScenario,
  };
}
